import { Environment } from '@lfg/core/enums';
import * as chains from 'wagmi/chains';

import { APP_ENV } from 'src/global/config/common.config';
import { KeyIndex } from 'src/global/types/common.type';

// Map our app's chain identifiers to wagmi chain objects and their IDs
export interface ChainInfo {
  chainId: number;
  name: string;
  mainnet: any;
  testnet: any;
  isTestnet: boolean;
  alchemyMainnet?: string;
  alchemyTestnet?: string;
  currency: {
    name: string;
    symbol: string;
    decimals: number;
  };
}

export const CHAINS_CONFIG: KeyIndex<ChainInfo> = {
  arbitrum: {
    chainId: chains.arbitrum.id,
    name: 'Arbitrum',
    mainnet: chains.arbitrum,
    testnet: chains.arbitrumSepolia,
    isTestnet: false,
    alchemyMainnet: 'https://arb-mainnet.g.alchemy.com/v2',
    alchemyTestnet: 'https://arb-sepolia.g.alchemy.com/v2',
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
  },
  base: {
    chainId: chains.base.id,
    name: 'Base',
    mainnet: chains.base,
    testnet: chains.baseSepolia,
    isTestnet: false,
    alchemyMainnet: 'https://base-mainnet.g.alchemy.com/v2',
    alchemyTestnet: 'https://base-sepolia.g.alchemy.com/v2',
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
  },
  bsc: {
    chainId: chains.bsc.id,
    name: 'BNB Smart Chain',
    mainnet: chains.bsc,
    testnet: chains.bscTestnet,
    isTestnet: false,
    alchemyMainnet: 'https://bnb-mainnet.g.alchemy.com/v2',
    alchemyTestnet: 'https://bnb-testnet.g.alchemy.com/v2',
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
  },
  eth: {
    chainId: chains.mainnet.id,
    name: 'Ethereum',
    mainnet: chains.mainnet,
    testnet: chains.sepolia,
    isTestnet: false,
    alchemyMainnet: 'https://eth-mainnet.g.alchemy.com/v2',
    alchemyTestnet: 'https://eth-sepolia.g.alchemy.com/v2',
    currency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
  },
  matic: {
    chainId: chains.polygon.id,
    name: 'Polygon',
    mainnet: chains.polygon,
    testnet: chains.polygonAmoy,
    isTestnet: false,
    alchemyMainnet: 'https://polygon-mainnet.g.alchemy.com/v2',
    alchemyTestnet: 'https://polygon-amoy.g.alchemy.com/v2',
    currency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
  },
  telos: {
    chainId: chains.telos.id,
    name: 'Telos',
    mainnet: chains.telos,
    testnet: chains.telcoinTestnet,
    isTestnet: false,
    currency: {
      name: 'TLOS',
      symbol: 'TLOS',
      decimals: 18,
    },
  },
};

// Get chainId for a given network in our application
export const getChainId = (network: string): number => {
  const chainConfig = CHAINS_CONFIG[network];
  if (!chainConfig) return 1;

  return APP_ENV !== Environment.PROD ? chainConfig.testnet.id : chainConfig.mainnet.id;
};

// Get the chain object for a given network in our application
export const getChainConfig = (network: string): any => {
  const chainConfig = CHAINS_CONFIG[network];
  if (!chainConfig) return chains.mainnet;

  return APP_ENV !== Environment.PROD ? chainConfig.testnet : chainConfig.mainnet;
};
